export const apiBaseUrl =
  process.env.REACT_APP_API_URL_STAGING || "http://localhost:4000/";
